import { Button } from "semantic-ui-react";

import React from "react";
import WholeSolPlaceSetting from "../hero/whole-sol-place-setting.jpg";
import Blueberry from "../hero/blueberry.jpeg";
import Juice from "../hero/juice.jpg";
import Strawberry from "../hero/strawberry-bol.jpg";
import USDA from "../hero/usda-organic-logo.png";
import FiveTwoEight from "../hero/5280-logo.png";
import WhiteTruffle from "../hero/White Tufflge Avocado.jpg";
import Westword from "../press-logos/Westword-logo.png";

const heroItems = [
  {
    background: "#F8BCD2",
    type: "color",
    width: "33.33%",
    content: (
      <div style={{ textAlign: "center" }}>
        <img
          src={FiveTwoEight}
          alt="5280 Logo"
          width="60%"
          style={{ margin: "auto" }}
        />
        <div style={{ marginBottom: "1em", fontStyle: "italic" }}>
          Readers' Choice 2019 - 2021
        </div>
        <div style={{ textAlign: "left" }}>
          <h2>Best New Restaurant</h2>
          <h2>Best Brunch</h2>
          <h2>Best Vegan/Vegetarian</h2>
          <h2>Best Takeout</h2>
        </div>
        {/*<Button primary inverted>*/}
        {/*SEE OUR MENU*/}
        {/*</Button>*/}
        {/*<Button primary inverted>*/}
        {/*ORDER ONLINE*/}
        {/*</Button>*/}
      </div>
    )
  },
  {
    background: WholeSolPlaceSetting,
    type: "image",
    width: "66.66%",
    alt: "WholeSol Place Setting"
  },
  {
    background: Juice,
    alt: "Juice",
    type: "image",
    width: "66.66%"
    // imageStyle: { objectPosition: "center 100%" },
  },
  {
    background: "#e5e3c6",
    type: "color",
    width: "33.33%",
    style: { alignItems: "top", textAlign: "center" },
    content: (
      <div>
        <img
          src={USDA}
          alt="USDA Logo"
          height={150}
          style={{ margin: "auto" }}
        />
        <h1 style={{ textAlign: "left", fontSize: "2.25rem" }}>
          The only USDA Certified Organic Juice Bar in Denver & Boulder
        </h1>
      </div>
    )
  },
  {
    background: Blueberry,
    type: "image",
    width: "33.33%",
    alt: "Blueberry"
  },
  {
    background: "#b4dddc",
    type: "color",
    width: "33.33%",
    style: { alignItems: "top" },
    content: (
      <div>
        <h2>
          Life is Short. <br />
          Lick the Bowl
        </h2>
        <p>100% organic transparent delicious</p>
      </div>
    )
  },
  {
    background: Strawberry,
    alt: "Strawberry",
    type: "image",
    width: "33.33%"
  },
  {
    background: "#cde3c7",
    type: "color",
    width: "33.33%",
    style: { alignItems: "top", textAlign: "center" },
    content: (
      <div>
        <img
          src={Westword}
          alt={"Westword Logo"}
          height={70}
          style={{ margin: "auto" }}
        />
        <h2 style={{ textAlign: "left" }}>Best of Denver</h2>
        <h2 style={{ textAlign: "left" }}>
          <a
            href="https://www.westword.com/best-of/2019/readers-choice/best-gluten-free-menu-11278716"
            style={{ color: "white" }}
          >
            Best Gluten-Free Menu, Readers' Choice 2019
          </a>
        </h2>
      </div>
    )
  },
  {
    background: WhiteTruffle,
    type: "image",
    width: "66.66%"
  }
];

export default heroItems;



// WEBPACK FOOTER //
// ./src/data/static/hero-items.jsx